export const componentDefault = "var(--seed-dimension-spacing-y-component-default)";
export const navToTitle = "var(--seed-dimension-spacing-y-nav-to-title)";
export const screenBottom = "var(--seed-dimension-spacing-y-screen-bottom)";
export const betweenText = "var(--seed-dimension-spacing-y-between-text)";